/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array, fragmentArray } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import type RubricColumn from '@linc-technologies/linced-common/models/reports/rubric-column';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: reports.Rubric.
export default class Rubric extends Model {
  declare [Type]: 'reports/rubric';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('string', { defaultValue: '' })
  declare subjectId: string;

  @array('string')
  declare milestoneIds: StatefulArray<string>;

  @attr('string', { defaultValue: '' })
  declare templateSubjectId: string;

  @array('string')
  declare templateMilestoneIds: StatefulArray<string>;

  @fragmentArray('reports/rubric-column')
  declare columns: FragmentArray<RubricColumn>;

  @attr('boolean', { defaultValue: false })
  declare isActive: boolean;

  @attr('boolean', { defaultValue: false })
  declare isGlobal: boolean;

  @attr('number', { defaultValue: 0 })
  declare validFrom: number;

  @attr('string', { defaultValue: '' })
  declare next: string;

  // The RubricFamily this rubric belongs to. Rubrics saved before families
  // existed have none and count as part of the default family.
  @attr('string', { defaultValue: '' })
  declare familyId: string;
}
